import React, { memo } from 'react';
import { BorderRadiusTokens, ColorTokens, DividerSizeTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, SizeTypeTokens, StackAlignItems, StackJustifyContent, StackType, } from '@voltmoney/schema';
import Stack from '../stack/Stack';
import Typography from '../typography/Typography';
import Space from '../space/Space';
import Divider from '../divider/Divider';
import { Icon } from "../icon/Icon";
import { Platform, TouchableOpacity, View } from "react-native";
/**
 * Primary UI component for user interaction
 */
const AmountCardMessageBase = ({ id, title, margin = {
    horizontal: SizeTypeTokens.XL,
    vertical: SizeTypeTokens.XL,
    bottom: SizeTypeTokens.XL,
}, subTitle, message, infoAction, isLoanExpired = false, triggerAction }) => {
    return (React.createElement(Stack, { bgColor: ColorTokens.Primary_05, borderConfig: {
            borderRadius: BorderRadiusTokens.BR3,
        }, padding: margin, children: [
            React.createElement(Space, { size: SizeTypeTokens.LG }),
            React.createElement(Stack, null,
                React.createElement(Typography, { label: title, fontFamily: FontFamilyTokens.Inter, fontWeight: '400', lineHeight: 18, fontSize: FontSizeTokens.XS, color: ColorTokens.Grey_Charcoal }),
                React.createElement(Space, { size: SizeTypeTokens.MD }),
                React.createElement(Stack, { type: StackType.row, alignItems: StackAlignItems.center, justifyContent: StackJustifyContent.center },
                    React.createElement(View, { style: {
                            position: 'relative',
                            bottom: Platform.OS === 'ios' ? 2 : 0
                        } },
                        React.createElement(Typography, { label: '₹', fontFamily: FontFamilyTokens.Inter, fontWeight: '700', fontSize: FontSizeTokens.XXXL, lineHeight: 32, color: ColorTokens.Grey_Night })),
                    React.createElement(Space, { size: SizeTypeTokens.XS }),
                    React.createElement(Typography, { id: id, label: subTitle, fontFamily: FontFamilyTokens.Poppins, fontWeight: '700', lineHeight: 32, fontSize: FontSizeTokens.XXXL, color: ColorTokens.Grey_Night }),
                    isLoanExpired && (React.createElement(TouchableOpacity, { style: {
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            justifyContent: 'center',
                            position: 'relative',
                            bottom: Platform.OS === 'ios' ? 4 : 0
                        }, onPress: () => {
                            infoAction &&
                                triggerAction(infoAction);
                        } },
                        React.createElement(Space, { size: SizeTypeTokens.Size6 }),
                        React.createElement(Icon, { name: IconTokens.SYSTEM_INFO_DLS, size: IconSizeTokens.LG, color: ColorTokens.Grey_Charcoal }))))),
            message && React.createElement(Space, { size: SizeTypeTokens.LG }),
            message && React.createElement(Divider, { size: DividerSizeTokens.SM, margin: {
                    vertical: SizeTypeTokens.XS,
                }, color: ColorTokens.Primary_10 }),
            message && React.createElement(Space, { size: SizeTypeTokens.LG }),
            message && (React.createElement(Typography, { label: message, fontFamily: FontFamilyTokens.Inter, numberOfLines: 4, fontWeight: '400', lineHeight: 18, fontSize: FontSizeTokens.XS, color: ColorTokens.Grey_Charcoal })),
        ] }));
};
export default memo(AmountCardMessageBase);
export { AmountCardMessageBase };
